import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { EMPTY_STRING } from "@tekion/tekion-base/app.constants";
import { notificationFromSPPayload } from '../../utils/helper.notification';
import TokenManager from "../../utils/TokenManager";
export const ICON_CLASSES = new Map([['requester', 'icon-person-outline'], ['cc_list', 'icon-avatar-outline'], ['mentions', 'icon-avatar-outline']]);
export const SUPPORT_PORTAL = {
  TITLE: __('Support Portal'),
  NAME: 'support_portal'
};
export const OEM_PORTAL = {
  TITLE: __('OEM Portal'),
  NAME: 'oem_portal'
};
const COMMON_NOTIFICATION_CONFIG = {
  helper: notificationFromSPPayload,
  channel: 'private-tap-helpdesk-<email>',
  ticketNotificationPusherEvent: 'ticket.notification',
  ticketNotificationUpdatePusherEvent: 'ticket.notification.update'
};
export const NOTIFICATION_CONFIG = {
  [SUPPORT_PORTAL.NAME]: _objectSpread(_objectSpread({}, COMMON_NOTIFICATION_CONFIG), {}, {
    title: SUPPORT_PORTAL.TITLE,
    url: '/tapapi/helpdesk/v1/public/notifications',
    redirectUrl: '/support/dashboard?ticketId={itemId}',
    bulkUpdateRedirectUrl: '/support/bulkupdate/{itemId}',
    authEndPoint: '/tapapi/helpdesk/v1/public/pusher/auth',
    isPartnerSite: false,
    getToken: () => TokenManager.getItem(TokenManager.accessTokenKey),
    tokenPropertyName: 'tap-api-token'
  }),
  [OEM_PORTAL.NAME]: _objectSpread(_objectSpread({}, COMMON_NOTIFICATION_CONFIG), {}, {
    title: OEM_PORTAL.TITLE,
    url: '/tapapi/helpdesk/v1/public/oem_customer_portal/notifications',
    redirectUrl: '/oem/support/tickets?ticketId={itemId}',
    bulkUpdateRedirectUrl: EMPTY_STRING,
    authEndPoint: '/tapapi/helpdesk/v1/public/pusher/oem_customer_portal/auth',
    isPartnerSite: true,
    getToken: () => TokenManager.getItem(TokenManager.accessTokenKey),
    tokenPropertyName: 'access_token'
  })
};
export const TAP_HEADER_HEIGHT = 63;
export const TAP_FOOTER_HEIGHT = 22;
export const DRAWER_HEADER_HEIGHT = 55;
export const TAB_HEADER_HEIGHT = 50;
export const NUMBER_OF_ROWS = 25;
export const NOTIFICATIONS = {
  ONLY_SHOW_UNREAD_TOGGLE: __('Only show unread'),
  LABEL: __('Notifications'),
  MARK_ALL_AS_READ: __('Mark All as Read'),
  ALL_NOTIFICATIONS_FROM_LAST_30_DAYS: __('That\'s all your notifications from the last 30 days'),
  NO_NOTIFICATIONS_FROM_LAST_30_DAYS: __('No notifications from the last 30 days')
};